<div (click)="open()" (keypress)="open()" tabindex="0" #container class="container">
  <ng-content></ng-content>
  @if (isOpen()) {
    <div class="popup">
      <form class="dates" [formGroup]="form">
        <input formControlName="start" id="start" type="date" [min]="min()" [max]="max()" />
        <input formControlName="end" id="end" type="date" [min]="min()" [max]="max()" />
      </form>
      <div class="actions">
        <app-button i18n variant="outline-primary" (buttonClick)="cancel($event)">Reset</app-button>
        <app-button i18n variant="primary" [disabled]="form.invalid" (buttonClick)="apply($event)">Apply</app-button>
      </div>
    </div>
  }
</div>
